export default function (editor, opts = {}) {
  const { bindCollectionOptions, labelColForm, projectId, collections, labelColName } = opts;
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  const { collection } = bindCollectionOptions;
  let addRemoveCollectionOption = [{ value: '', name: '- Select One -' }];
  if (typeof collection !== 'undefined') {
    addRemoveCollectionOption.push({
      value: 'getFromPageContext',
      name: `Get Page Context Collection: ${collection.collectionTitle}`,
    });
  }
  addRemoveCollectionOption.push({
    value: 'getFromParentCollection',
    name: `Get from Parent Collection`,
  });

  domc.addType('add-remove-collection-form', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          name: labelColForm,
          droppable: ':not(form)',
          draggable: ':not(form)',
          method: '',
          action: '',
          collectionName: '',
          collectionField: '',
          'data-form-type': 'addToCollection',
          collectionFrom: 'getFromParentCollection',
          style: {
            width: 'max-content',
            display: 'inline-block',
            padding: '5px',
          },
          projectId: projectId,
          serverUrl: `${process.env.REACT_EXCHANGE_ENGINE}`,
          traits: [
            {
              type: 'select',
              label: 'Form Type',
              name: 'data-form-type',
              options: [
                { value: 'addToCollection', name: 'Add To Collection' },
                { value: 'removeFromCollection', name: 'Remove From Collection' },
              ],
              changeProp: 1,
            },
            {
              type: 'webconnect-event',
              label: 'Event',
              name: 'onsubmit',
            },
            ...domc.getType('default').model.prototype.defaults.traits,
          ],
          attributes: { method: 'POST', action: '', 'data-form-type': 'addToCollection' },
        },

        init() {
          const attrs = this.getAttributes();
          const collectionName = attrs['data-form-collection'];
          const parentCollectionName = attrs['data-form-parent-collection'];
          const formtype = attrs['data-form-type'];

          this.addTrait(
            [
              {
                type: 'addTo-removeFrom-form-element-trait',
                label: 'Add To Collection',
                name: 'data-element-field-name',
                customLabel: 'Get Value From',
                content: false,
              },
              {
                type: 'select',
                label: labelColName,
                name: 'collectionFrom',
                options: addRemoveCollectionOption,
                changeProp: 1,
              },
            ],
            { at: 2 },
          );

          this.on('change:collectionFrom', this.handleCollectionFromChange);
          this.on('change:data-form-type', this.handleFormTypeChange);
        },

        async handleFormTypeChange() {
          const attrs = this.getAttributes();
          const formType = this.get('data-form-type');

          attrs['data-form-type'] = formType;
          this.addAttributes(attrs);
          let collectionFromLabel =
            formType === 'addToCollection' ? 'Add Collection' : 'Remove Collection';
          let dataElementFieldNameLabel =
            formType === 'addToCollection' ? 'Add To Collection' : 'Remove From Collection';
          const component = editor.getSelected();
          let collectionNameTrait = component.getTrait('collectionFrom');

          if (typeof collectionNameTrait !== 'undefined') {
            collectionNameTrait.set({
              label: collectionFromLabel,
            });
          }

          let addToRemoveFromTrait = component.getTrait('data-element-field-name');
          if (typeof addToRemoveFromTrait !== 'undefined') {
            addToRemoveFromTrait.set({
              label: dataElementFieldNameLabel,
            });
          }
        },

        async handleCollectionFromChange() {
          const attrs = this.getAttributes();
          const collectionFrom = this.get('collectionFrom');
          const parentCollection = attrs['data-form-parent-collection'];
          const parentCollectionField = attrs['data-form-element-collection'];
          let selectedParentCollection = collections.filter(
            (e) => e.collectionName === parentCollection,
          );

          attrs['collectionFrom'] = collectionFrom;
          if (collectionFrom === 'getFromParentCollection') {
            let formElementFieldRefCollection = selectedParentCollection[0].fields.filter(
              (field) => field.fieldName === parentCollectionField,
            );

            attrs['data-form-collection'] =
              formElementFieldRefCollection[0].refCollection.collectionName;
          } else {
            attrs['data-form-collection'] = collection.collectionId;
          }

          this.addAttributes(attrs);
        },
      },
      {
        isComponent(el) {
          if (
            el.getAttribute &&
            el.getAttribute('data-gjs-type') === 'add-remove-collection-form'
          ) {
            return {
              type: 'add-remove-collection-form',
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {
        this.listenTo(model, 'change:collectionFrom', this.updateScript);
        this.listenTo(model, 'change:data-form-type', this.updateScript);
      },
    }),
  });
}
